<template>
  <div class="social-share-bar__mobile">
    <ShareBlack
      v-show="url"
      class="social-share-bar__mobile__icon"
      @click="shareViaWebShare"
    />
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { ShareBlack } from '~/components/General/Icons';
import { useUiNotification } from '~/composables';
import { useI18n } from '~/helpers/hooks/usei18n';

export default defineComponent({
  name: 'SocialShareBarMobile',
  components: {
    ShareBlack,
  },
  props: {
    url: {
      type: String,
      default: 'www.sognidicristallo.com',
    },
    quote: {
      type: String,
      default: 'Sogni di Cristallo',
    },
    hashtags: {
      type: String,
      default: 'sognidicristallo',
    },
  },
  setup(props) {
    const { send: sendNotification } = useUiNotification();
    const trans = useI18n();

    const isWebShareSupported = computed(
      () => navigator && 'share' in navigator
    );

    const shareViaWebShare = async () => {
      if (!isWebShareSupported.value) {
        sendNotification({
          id: Symbol('social_web_share_error'),
          message: trans.t('An error occurred while sharing the content.'),
          type: 'danger',
          icon: 'error',
          persist: false,
          title: 'Error',
        });
        return;
      }

      try {
        await navigator.share({
          title: 'Sogni di Cristallo',
          text: props.quote,
          url: props.url,
        });
      } catch (error) {
        console.error('Failed to share via Web Share API:', error);
      }
    };

    return {
      shareViaWebShare,
    };
  },
});
</script>

<style lang="scss" scoped>
.social-share-bar__mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  gap: 1.25rem;
  &__icon {
    width: 2rem;
    height: 2rem;
  }
}
@include from-desktop-min {
  .social-share-bar__mobile {
    display: none;
  }
}
</style>
